import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PAYMENT_STANDING_ORDER } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import PaymentSuccess from '../presentational/PaymentSuccess';
import { selectPayee, setSelectedPayee } from 'lib/slices';

const PaymentSuccessContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const selectedPayee = useSelector(selectPayee);

    const handleSuccessClick = () => {
        navigate(PAYMENT_STANDING_ORDER);
    };

    useEffect(() => {
        if (!selectedPayee || !location.state?.data) {
            navigate(PAYMENT_STANDING_ORDER);
        }

        return () => {
            dispatch(setSelectedPayee(null));
        };
    }, [dispatch, navigate, location.state, selectedPayee]);

    return (
        <PageContainer>
            {location.state?.data && (
                <PaymentSuccess
                    data={location.state.data}
                    onSuccessClick={handleSuccessClick}
                />
            )}
        </PageContainer>
    );
};

export default PaymentSuccessContainer;
